import {
  breakpoints,
  colors,
  spacings,
  typography,
} from '@src/common/styles/valueTokens';

export const theme = {
  palette: {
    primary: {
      primary: colors.primary['40'],
      onPrimary: colors.primary['100'],
      primaryContainer: colors.primary['90'],
      onPrimaryContainer: colors.primary['30'],
      primaryFixed: colors.primary['90'],
      primaryFixedDim: colors.primary['80'],
      onPrimaryFixed: colors.primary['10'],
      onPrimaryFixedVariant: colors.primary['30'],
      inversePrimary: colors.primary['80'],
    },
    secondary: {
      secondary: colors.secondary['40'],
      onSecondary: colors.secondary['100'],
      secondaryContainer: colors.secondary['90'],
      onSecondaryContainer: colors.secondary['30'],
      secondaryFixed: colors.secondary['90'],
      secondaryFixedDim: colors.secondary['80'],
      onSecondaryFixed: colors.secondary['10'],
      onSecondaryFixedVariant: colors.secondary['30'],
    },
    tertiary: {
      tertiary: colors.tertiary['40'],
      onTertiary: colors.tertiary['100'],
      tertiaryContainer: colors.tertiary['90'],
      onTertiaryContainer: colors.tertiary['30'],
      tertiaryFixed: colors.tertiary['90'],
      tertiaryFixedDim: colors.tertiary['80'],
      onTertiaryFixed: colors.tertiary['10'],
      onTertiaryFixedVariant: colors.tertiary['30'],
    },
    error: {
      error: colors.error['40'],
      onError: colors.error['100'],
      errorContainer: colors.error['90'],
      onErrorContainer: colors.error['30'],
    },
    warning: {
      warning: '#835414',
      border: colors.utility.warning['200'],
      onWarning: colors.error['100'],
      warningContainer: colors.utility.warning['50'],
      onWarningContainer: '#2B1700',
    },
    success: {
      success: '#1D6B50',
      onSuccess: colors.error['100'],
      successContainer: '#A7F2D0',
      onSuccessContainer: '#002115',
    },
    surface: {
      surface: colors.neutral['98'],
      surfaceDim: colors.neutral['87'],
      surfaceBright: colors.neutral['98'],
      surfaceContainerLowest: colors.neutral['100'],
      surfaceContainerLow: colors.neutral['96'],
      surfaceContainer: colors.neutral['94'],
      surfaceContainerHigh: colors.neutral['92'],
      surfaceContainerHighest: colors.neutral['90'],
      onSurface: colors.neutral['10'],
      onSurfaceVariant: colors.neutralVariant['30'],
      outline: colors.neutralVariant['50'],
      outlineVariant: colors.neutralVariant['80'],
      inverseSurface: colors.neutral['20'],
      inverseOnSurface: colors.neutral['95'],
    },
    scrim: colors.neutral['0'],
    shadow: colors.neutral['0'],
    table: {
      rowDraggingColor: '#F5F5F5',
    },
    border: {
      primary: colors.border.primary,
    },
  },
  typography,
  spacing: {
    1: spacings['1'],
    2: spacings['2'],
    3: spacings['3'],
    4: spacings['4'],
    5: spacings['5'],
    6: spacings['6'],
    7: spacings['7'],
    8: spacings['8'],
    9: spacings['9'],
    12: spacings['12'],
    15: spacings['15'],
    16: spacings['16'],
  },
  breakpoints: {
    small: `${breakpoints.small}px`,
    medium: `${breakpoints.medium}px`,
    large: `${breakpoints.large}px`,
    xlarge: `${breakpoints.xlarge}px`,
  },
  table: {
    border: {
      primary: `1px solid ${colors.neutralVariant['80']}`,
      secondary: `2px solid ${colors.neutralVariant['80']}`,
    },
  },
  radius: {
    around: '16px',
    bottom: '0px 0px 16px 16px',
  },
} as const;

export type Theme = typeof theme;
